<template>
    <b-modal
        title-tag="h2"
        :title="modalTitle"
        :lazy="true"
        :visible="isOpen"
        no-close-on-esc
        no-close-on-backdrop
        @shown="shown"
    >
        <b-form-group label-for="date" label-cols="4" label="Date:">
            <date-picker
                id="date"
                name="date"
                :config="datePickerOptions"
                v-model="date"
                placeholder="Date (required)"
                v-validate="'required'"
                :class="{ 'border-danger': errors.has('date') }"
            />
        </b-form-group>

        <b-form-group
            label-cols="4"
            label="Starting Balance:"
            label-for="startBalance"
        >
            <b-form-input
                id="startBalance"
                name="startBalance"
                ref="startBalance"
                type="text"
                placeholder="Starting cash balance (required)"
                v-model="startBalance"
                :class="{
                    'border-danger': errors.has('startBalance')
                }"
                v-validate="
                    'required|min_value:0.01|max_value:99999999|numericalWithDecimal|decimal:2'
                "
            ></b-form-input>
        </b-form-group>

        <b-form-group
            label-cols="4"
            label="Ending Balance:"
            label-for="endBalance"
        >
            <b-form-input
                id="endBalance"
                name="endBalance"
                type="text"
                placeholder="Ending cash balance (optional)"
                v-model="endBalance"
                :class="{
                    'border-danger': errors.has('endBalance')
                }"
                v-validate="
                    'min_value:0|max_value:99999999|numericalWithDecimal|decimal:2'
                "
            ></b-form-input>
        </b-form-group>

        <b-form-group label-for="note" label-cols="4" label="Note:">
            <b-form-textarea
                id="note"
                name="note"
                size="sm"
                placeholder="Note (optional)"
                v-model="note"
            ></b-form-textarea>
        </b-form-group>

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import moment from "moment";
import CustomRulesVeeValidate from "@/mixins/custom-rules-veevalidate";
import BillingCash from "@/services/billing/billing-cash";

export default {
    mixins: [CustomRulesVeeValidate],
    components: {
        Loader
    },
    data() {
        return {
            cashId: null,
            startBalance: "0.00",
            endBalance: "0.00",
            date: null,
            note: null,
            isOpen: false,
            isNew: true,
            isLoading: false,
            datePickerOptions: {
                format: ""
            },
            modalTitle: "New Reconciliation"
        };
    },
    methods: {
        async open(cash = null) {
            this.isOpen = true;
            this.isNew = true;
            this.datePickerOptions.format = this.getDateFormat();
            this.date = moment().tz(this._timeZone);
            if (cash) {
                this.isNew = false;
                this.modalTitle = "Edit Reconciliation";
                this.cashId = cash.id;
                this.date = this._carbonDateDisplay(cash.date);
                this.startBalance = cash.start_amount.toFixed(2);
                this.endBalance = cash.end_amount.toFixed(2);
                this.note = cash.description;
            }
        },
        shown() {
            if (this.isNew) {
                this.$refs["startBalance"].setSelectionRange(0, 0);
                this.$refs["startBalance"].focus();
            }
        },
        close() {
            this.isOpen = false;
        },
        async proceed() {
            let valid = await this.$validator.validateAll();

            if (!valid) {
                return false;
            }

            try {
                this.isLoading = true;
                const currentDateUnix = this._fromDateStrToDateTime(
                    this.date,
                    true
                );

                let newCashData = {};
                newCashData["date"] = currentDateUnix;
                newCashData["start_amount"] = Number(this.startBalance);
                newCashData["end_amount"] = Number(this.endBalance);
                newCashData["description"] = this.note;

                const res = this.cashId
                    ? await BillingCash.updateCash(newCashData, this.cashId)
                    : await BillingCash.addCash(newCashData);

                if (res.code == 200) {
                    this.isLoading = false;
                    this._message(
                        `Successfully ${this.isNew ? "created" : "updated"}`
                    );
                    this.$emit("reload");
                    this.close();
                } else {
                    throw new Error(
                        `Error: Cash failed to be ${
                            this.isNew ? "created" : "updated"
                        }`
                    );
                }
            } catch (error) {
                this.isLoading = false;
                this._message(error.message, "danger");
            }
        }
    }
};
</script>
